document.addEventListener('DOMContentLoaded', function () {
  var directories = document.querySelectorAll('[data-brand-directory]');

  if (!directories.length) return;

  directories.forEach(function (directory) {
    var searchInput = directory.querySelector('[data-brand-search]');
    var groupFilter = directory.querySelector('[data-brand-group-filter]');
    var categoryFilter = directory.querySelector('[data-brand-category-filter]');
    var resetButtons = Array.prototype.slice.call(
      directory.querySelectorAll('[data-reset-filters]')
    );
    var cards = Array.prototype.slice.call(
      directory.querySelectorAll('[data-brand-card]')
    );
    var letterButtons = Array.prototype.slice.call(
      directory.querySelectorAll('[data-letter-filter]')
    );
    var emptyState = directory.querySelector('[data-empty-state]');
    var resultsCount = directory.querySelector('[data-results-count]');
    var lettersToggle = directory.querySelector('[data-letters-toggle]');
    var lettersPanel = directory.querySelector('[data-letters-panel]');

    var activeLetter = '';
    var MOBILE_BREAKPOINT = 767;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function debounce(fn, delay) {
      var timer;
      return function () {
        var context = this;
        var args = arguments;

        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    }

    function parseCategories(value) {
      if (!value) return [];

      return value
        .split(',')
        .map(function (item) {
          return item.trim();
        })
        .filter(function (item) {
          return item !== '';
        });
    }

    function normalizeText(value) {
      return (value || '').trim().toLowerCase();
    }

    function closeLettersPanel() {
      if (!lettersToggle || !lettersPanel) return;

      lettersPanel.classList.remove('is-open');
      lettersToggle.setAttribute('aria-expanded', 'false');
    }

    function openLettersPanel() {
      if (!lettersToggle || !lettersPanel) return;

      lettersPanel.classList.add('is-open');
      lettersToggle.setAttribute('aria-expanded', 'true');
    }

    function syncLettersPanelForViewport() {
      if (!lettersToggle || !lettersPanel) return;

      if (isMobile()) {
        if (!lettersPanel.classList.contains('is-open')) {
          lettersToggle.setAttribute('aria-expanded', 'false');
        }
      } else {
        lettersPanel.classList.remove('is-open');
        lettersToggle.setAttribute('aria-expanded', 'false');
      }
    }

    function setActiveLetter(nextLetter) {
      activeLetter = nextLetter || '';

      letterButtons.forEach(function (button) {
        var value = button.getAttribute('data-letter-filter') || '';
        var isActive = value === activeLetter;

        if (activeLetter === '' && value === '') {
          isActive = true;
        }

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function getCurrentFilters() {
      return {
        searchTerm: searchInput ? normalizeText(searchInput.value) : '',
        selectedGroup: groupFilter ? groupFilter.value.trim() : '',
        selectedCategory: categoryFilter ? categoryFilter.value.trim() : ''
      };
    }

    function cardMatchesBaseFilters(card, filters) {
      var brandName = normalizeText(card.getAttribute('data-brand-name'));
      var cardGroup = (card.getAttribute('data-brand-group') || '').trim();
      var cardCategories = parseCategories(
        card.getAttribute('data-brand-categories') || ''
      );

      var matchSearch =
        filters.searchTerm === '' || brandName.indexOf(filters.searchTerm) !== -1;

      var matchGroup =
        filters.selectedGroup === '' || cardGroup === filters.selectedGroup;

      var matchCategory =
        filters.selectedCategory === '' ||
        cardCategories.indexOf(filters.selectedCategory) !== -1;

      return matchSearch && matchGroup && matchCategory;
    }

    function updateLetterAvailability() {
      var filters = getCurrentFilters();
      var counters = {};

      cards.forEach(function (card) {
        var cardLetter = (card.getAttribute('data-letter') || '').trim();

        if (cardMatchesBaseFilters(card, filters) && cardLetter !== '') {
          counters[cardLetter] = (counters[cardLetter] || 0) + 1;
        }
      });

      letterButtons.forEach(function (button) {
        var value = button.getAttribute('data-letter-filter') || '';

        if (value === '') {
          button.classList.remove('is-disabled');
          button.disabled = false;
          return;
        }

        var hasItems = !!counters[value];
        button.classList.toggle('is-disabled', !hasItems);
        button.disabled = !hasItems;
      });

      if (activeLetter !== '' && !counters[activeLetter]) {
        setActiveLetter('');
      }
    }

    function updateResultsLabel(visibleCount) {
      if (!resultsCount) return;

      var searchTerm = searchInput ? searchInput.value.trim() : '';
      var selectedGroup =
        groupFilter && groupFilter.value
          ? groupFilter.options[groupFilter.selectedIndex].text
          : '';
      var selectedCategory =
        categoryFilter && categoryFilter.value
          ? categoryFilter.options[categoryFilter.selectedIndex].text
          : '';

      var text =
        visibleCount === 1
          ? '1 brand trovato'
          : visibleCount + ' brand trovati';

      if (searchTerm) {
        text += ' per "' + searchTerm + '"';
      } else if (selectedCategory) {
        text += ' nella categoria ' + selectedCategory;
      } else if (selectedGroup) {
        text += ' nel gruppo ' + selectedGroup;
      }

      resultsCount.textContent = text;
    }

    function updateUIState() {
      var hasSearch = !!(searchInput && searchInput.value.trim() !== '');
      var hasGroup = !!(groupFilter && groupFilter.value.trim() !== '');
      var hasCategory = !!(categoryFilter && categoryFilter.value.trim() !== '');
      var hasLetter = activeLetter !== '';
      var hasActiveFilters = hasSearch || hasGroup || hasCategory || hasLetter;

      directory.classList.toggle('has-active-search', hasSearch);

      if (groupFilter) {
        groupFilter.classList.toggle('is-active', hasGroup);
      }

      if (categoryFilter) {
        categoryFilter.classList.toggle('is-active', hasCategory);
      }

      resetButtons.forEach(function (button) {
        button.hidden = !hasActiveFilters;
      });
    }

    function applyFilters() {
      var filters = getCurrentFilters();
      var visibleCount = 0;

      updateLetterAvailability();

      cards.forEach(function (card) {
        var cardLetter = (card.getAttribute('data-letter') || '').trim();
        var baseMatch = cardMatchesBaseFilters(card, filters);
        var matchLetter = activeLetter === '' || cardLetter === activeLetter;
        var show = baseMatch && matchLetter;

        card.style.display = show ? '' : 'none';

        if (show) {
          visibleCount += 1;
        }
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }

      updateResultsLabel(visibleCount);
      updateUIState();
    }

    function resetAllFilters() {
      if (searchInput) searchInput.value = '';
      if (groupFilter) groupFilter.value = '';
      if (categoryFilter) categoryFilter.value = '';

      setActiveLetter('');
      applyFilters();

      if (isMobile()) {
        closeLettersPanel();
      }
    }

    var debouncedApplyFilters = debounce(applyFilters, 150);
    var debouncedSyncOnResize = debounce(function () {
      syncLettersPanelForViewport();
      applyFilters();
    }, 120);

    if (searchInput) {
      searchInput.addEventListener('input', debouncedApplyFilters);
    }

    if (groupFilter) {
      groupFilter.addEventListener('change', applyFilters);
    }

    if (categoryFilter) {
      categoryFilter.addEventListener('change', applyFilters);
    }

    resetButtons.forEach(function (button) {
      button.addEventListener('click', resetAllFilters);
    });

    letterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        var value = button.getAttribute('data-letter-filter') || '';
        setActiveLetter(value);
        applyFilters();

        if (isMobile()) {
          closeLettersPanel();
        }
      });
    });

    if (lettersToggle && lettersPanel) {
      lettersToggle.addEventListener('click', function () {
        var isOpen = lettersPanel.classList.contains('is-open');

        if (isOpen) {
          closeLettersPanel();
        } else {
          openLettersPanel();
        }
      });
    }

    window.addEventListener('resize', debouncedSyncOnResize);

    syncLettersPanelForViewport();
    setActiveLetter('');
    applyFilters();
  });
});